module.exports = __webpack_public_path__ + "img/work4.dad58e01.png";